import React from 'react';
import { Grid, List } from 'semantic-ui-react';

import InformationItem from '../InformationItem';

const Compensation = ({
  payment,
  loa,
  passenger,
  createMarkup,
  paxBankAccountHolder,
  donatedAmount
}) => {
  const { employer, affiliate, bankName } = passenger;
  const { iban, bicSwift, paxPaypalId, paxTransferChannel } =
    payment || {};
  const { signedLoaDocumentUrl } = loa || {};

  return (
    <Grid.Column>
      <List>
        {payment &&
          (iban || bicSwift || paxPaypalId || paxTransferChannel) && (
            <InformationItem
              icon='university'
              content={
                <span
                  dangerouslySetInnerHTML={createMarkup(
                    iban,
                    bicSwift,
                    paxPaypalId,
                    paxTransferChannel
                  )}
                />
              }
              info='PAX bank information'
            />
          )}
        <InformationItem
          icon='user'
          content={`PAX bank account holder: ${paxBankAccountHolder || '-'}`}
          info='PAX bank account holder'
        />
        <InformationItem
          icon='send'
          content={`Donated amount: ${
            donatedAmount || donatedAmount === 0 ? donatedAmount : '-'
          }`}
          info='Donated amount'
        />

        {signedLoaDocumentUrl && (
          <InformationItem
            icon='file outline'
            content={
              <a
                href={signedLoaDocumentUrl}
                target='_blank'
                style={{ wordBreak: 'break-all' }}
              >
                {signedLoaDocumentUrl}
              </a>
            }
            info='PAX signed loa'
          />
        )}
        <InformationItem
          icon='building'
          content={employer}
          info='PAX employer'
        />
        <InformationItem
          icon='exchange'
          content={affiliate && affiliate.name ? affiliate.name : ''}
          info='PAX affiliate'
        />
        <InformationItem icon='money' content={bankName} info='Bank name' />
      </List>
    </Grid.Column>
  );
};

export default Compensation;



// WEBPACK FOOTER //
// ./src/component/PassengerView/Compensation.js